import { render, staticRenderFns } from "./SavedProducts.vue?vue&type=template&id=6283cf56&"
import script from "./SavedProducts.vue?vue&type=script&lang=js&"
export * from "./SavedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports